import React, { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className = "",
}) => {
  return (
    <div className={`container-fluid min-vh-100 bg-body-tertiary px-3 px-lg-4 py-4 ${className}`.trim()}>
      {children}
    </div>
  );
};

export default PageContainer;
